<template>
  <w-sliding-panel
    class="form-aside-mobile w-theme--dark"
    position="bottom"
    size="75%"
    :is-open="isOpen"
    @close="$emit('close')"
  >
    <template v-if="documentTitle" #actions>
      <document-title :document-title="documentTitle" />
    </template>

    <form-aside-button
      v-for="(tab, index) in tabs"
      :key="'tab_' + tab.name + '_' + index"
      size="lg"
      :tab="tab"
      :active="currentTabName == tab.name"
      :index="index"
      @tab-selected="$emit('change-tab', tab)"
    />

    <template #footer>
      <w-flex direction="col" align="end" :gap="2">
        <w-button
          fluid
          variant="outlined"
          size="xl"
          icon="exit_to_app"
          class="actions-bar__outlined-button"
          text="Wyjdź bez zapisu"
          @click="$emit('cancel')"
        />

        <w-button
          fluid
          color="primary"
          size="xl"
          icon="save"
          text="Zapisz i wyjdź"
          @click="$emit('save', true)"
        />

        <app-version class="mt-3" :project-name="props.projectName" :version="props.version" />
      </w-flex>
    </template>
  </w-sliding-panel>
</template>
<script setup lang="ts">
import type { Tab } from '@/typings/tab';

import AppVersion from './AppVersion.vue';
import DocumentTitle from './DocumentTitle.vue';
import FormAsideButton from './FormAsideButton.vue';

const props = defineProps<{
  tabs: Tab[];
  version?: string;
  projectName?: string;
  documentTitle?: string;
  currentTabName: string;
  isOpen: boolean;
}>();

defineEmits({
  close: null,
  'change-tab': null,
  cancel: null,
  save: null,
});
</script>

<style lang="scss">
.form-aside-mobile {
  background: w.color('neutral', 75);

  .w-sliding-panel__content {
    padding-left: 0;
    padding-right: 0px;
  }

  .w-sliding-panel__footer {
    background: inherit;
  }
}
</style>
